import noScroll from 'no-scroll'
export default class Emoji {
 constructor (quill, options = {}) {
  this.quill = quill
  this.options = options
  this.fullscreen = false
  this.editorContainer = this.quill.container.parentNode.parentNode
 }
 handle () {
//   if (!this.fullscreen) {
//    this.fullscreen = true
//    this.editorContainer.className = 'editor-fullscreen'
//    noScroll.on()
//   }else{
//    this.fullscreen = false
//    this.editorContainer.className = ''
//    noScroll.off()
//   }
   console.log("8899===========================111")
 }
}